import React from 'react';
import styled from 'styled-components';

const StyledBall = styled.div<{ size?: number, fontSize?: string | number }>`
    display: flex;
    width: ${({ size }) => (size ? `${size}px` : '40px')};
    height: ${({ size }) => (size ? `${size}px` : '40px')};
    padding: 10px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0; 
    border-radius: 100px; 
    text-align: center;
    leading-trim: both;
    text-edge: cap;
    text-shadow: 0px 1px 0px rgba(3, 0, 20, 0.50);
    font-family: Syncopate;
    font-size: ${({ fontSize }) => (fontSize ? `${fontSize}px` : '18px')};
    font-style: normal;
    font-weight: 700;
    line-height: 100%;
    letter-spacing: -0.54px;
    text-transform: uppercase; 
`

export interface LotteryBallColors {
    purple: string;
    green: string;
    yellow: string;
    orange: string;
    pink: string;
    cyan: string;
    red: string;
}

interface LotteryBallProps {
  color: keyof LotteryBallColors;
  number?: number;
  style?: React.CSSProperties;
  size?: number;
  fontSize?: string | number;
}

const LotteryBall: React.FC<LotteryBallProps> = ({ color, number, style, size=40, fontSize=18 }) => {
  const styles = {
    purple: {
        backgroundColor: '#9465FF',
        boxShadow: `0px 0px ${size / 2}px 0px #060318 inset`,
    },
    green: {
        backgroundColor: 'rgba(102, 255, 182, 0.75)',
        boxShadow: `0px 0px ${size / 2}px 0px #050218 inset`,
    },
    yellow: {
        backgroundColor: `rgba(255, 231, 102, 0.75)`,
        boxShadow: `0px 0px ${size / 2}px 0px #030014 inset`,
    },
    orange: {
        backgroundColor: `rgba(255, 166, 102, 0.75)`,
        boxShadow: `0px 0px ${size / 2}px 0px #050218 inset`,
    },
    pink: {
        backgroundColor: `rgba(255, 102, 212, 0.75)`,
        boxShadow: `0px 0px ${size / 2}px 0px #050218 inset`,
    },
    cyan: {
        backgroundColor: `rgba(101, 246, 255, 0.75)`,
        boxShadow: `0px 0px ${size / 2}px 0px #050218 inset`,
    },
    red: {
        backgroundColor: `rgba(255, 102, 102, 0.75)`,
        boxShadow: `0px 0px ${size / 2}px 0px #050218 inset`,
    },
  };

  return (
    <StyledBall
      style={{
        ...style,
        ...styles[color]
      }}
      size={size}
      fontSize={fontSize}
    >
      {number}
    </StyledBall>
  );
};

export default LotteryBall;
